export const passportRegex = /^\d{4} \d{6}$/
export const passportCodeRegex= /^\d{3}-\d{3}$/
export const accountRegex = /^\d{20}$/
export const bankRegex = /^\d{9}$/
export const digitRegex = /[^0-9]/
export const INNRegex = /^\d{10}$/
export const phoneRegex = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/
// export const certRegex = /^(\d{3}(\d|[A-Z]){2}[A-Z]{3}\d{10})|(\d{2}KZK\d{10})|(\d{2}[A-Z]{4}\d{9})|(\d{2}[A-Z]{4}\d{10})$/
export const latinRegex = /^(\d|[A-Z])$/
export const certRegex = /^[A-Z0-9/]{12,21}$/
export const activateRegex = /^((\d){2}WTM\d{10})|(25HCN\d{10,11})|(26[A-Z0-9/]{2}001\d{6})$/
export const segnRegex = /^\d{8}$/

